import { useRoutes } from 'react-router-dom'

import Network from './Network'

const DataFlowsRouting = () => {
  return useRoutes([{ index: true, element: <Network />, id: 'data_flows_index' }])
}

export default DataFlowsRouting
